import { } from "angular"
import { Address } from "@idha/idha-types"
import { utilsModule } from "../utils-module"
import {findByZIP as findByZIPApi} from '@idha/idha-utils'
export {Address}
/**
 * IDHA TECNOLOGIA
 * 
 * Nome do Serviço: 'addressService'
 * Criação: 31/03/2018
 * Última modificação: 31/03/2018
 * 
 * Descrição:
 * 
 * Serviços destinados a métodos utilitários para a manipulação de enderenços
 * 
 * 
 * @author William Azevedo de Paula
 * @requires Address
 */
utilsModule.factory('addressService', ['$http',function ($http) {
    return {
        findByZIP: async function (cep: string) {
            return fetchAddressByCep(cep)
        }
    }
}])


export async function fetchAddressByCep(cep: string){
    try {
      const result:Address = await findByZIPApi(cep);
      if (result) {
        return result;
    } else {
        throw { messageCode: 'ZIP_NOT_FOUND' };
    }
    } catch (error) {
      console.error(error)
    }
  
  }
/**
 * Interface implementada pelo addressService
 */
export interface IAddressService {
    /**
     * Método para realização de busca de endereço por CEP, utilizando a API externa WIDENET
     * @param cep {string} cep a ser procurado
     * @returns promise contendo uma instância implementando a interface Address com dados de endereço encontrados
     * @throws Error lança a excessão ZIP_NOT_FOUND quando não encontrar um CEP
     * @see https://apps.widenet.com.br/busca-cep/api-de-consulta
     */
    findByZIP(cep: string): Promise<Address>
}